/**
 * Функция преобразует переданное значение в строку с добавлением суффикса "px".
 *
 * @param value - Значение, которое нужно преобразовать. Может быть:
 *   - `MaybeRef<number>` (числовое значение или реактивная ссылка из Vue).
 *   - `string` (строка).
 *
 * @returns Возвращает строку в формате "<значение>px".
 *
 * Пример использования:
 *
 * // Если передано число:
 * myFunction(10); // Вернёт: "10px"
 *
 * // Если передана строка:
 * myFunction("15"); // Вернёт: "15px"
 *
 * // Если используется реактивная ссылка (в контексте Vue):
 * import { ref } from 'vue';
 * const reactiveValue = ref(20);
 * myFunction(reactiveValue); // Вернёт: "20px"
 */
export default function (value: MaybeRef<number> | string): string {
  return `${value}px`;
}
